<div class="page-wrapper pt-4">
    <div class="page-content pt-0 pe-0 ps-0">
        <div class="">
            <div class="default_class">
                <div class="content-wrapper p-0">
                    <div class="container-fluid pt-2 pb-2">
                        <div class="row m-0 g-3">
                            <div class="col-xl-7">
                                
                                <div class="card shadow-sm">
                                    <div class="card-body">

                                          <div class="about_course">
                                        <div class="job-details-wrap mb-4">
                                            <div class="job-details-info">
                                                <div class="thumb">
                                                   
                                                </div>
                                                <div class="content">
                                                    <h4 class="title mb-0">{{params.COURSESHD_NAME}}
                                                        <!-- {{courseDetails.LASTNAME}} -->
                                                    </h4>
                                                  
                                                    <ul class="info-list ps-0">
                                                        <li class="ps-0">Internship:
                                                            <span class="me-2 ms-0 fw-bold">{{params.COURSE_NAME}}
                                                            </span>
                                                        </li> <br>
                                                        <li class="ps-0">
                                                             <img [src]="params.IMAGE_URL" alt="profile-sample1"
                                                            class="background img-fluid" />
                                                        </li>
        
                                                    </ul>
                                                    <!-- <h6 class="mt-2"> {{params.REGISTRATION_STARTDATE| date: 'dd-MM-yyyy'}} - {{params.REGISTRATION_ENDDATE | date: 'dd-MM-yyyy'}} </h6> -->
                                                    <!-- <ul class="info-list ps-0">
                                                        <li class="ps-0">Course:
                                                            <span class="me-2 ms-0 fw-bold">{{sessionDetails.job_skills
                                                                |
                                                                date:'dd-MMM-yyyy'}} to {{sessionDetails.COURSESHD_ENDDATE |
                                                                date:'dd-MMM-yyyy'}}</span>
                                                        </li>
        
                                                    </ul>
                                                    <h6 class="mt-2"> {{sessionDetails.COURSESHD_AMOUNT|currency:'INR'}} </h6> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <h6>About Course</h6>
                                          <p class="mb-0">  {{params.COURSE_DESCRIPTION}} </p>
                                            <h6 class="mt-4">Who Can Apply</h6>
                                            <p>{{params.courseshd_canappy}}</p>

                                            <h6 class="mt-4">Terms Of Engagement</h6>
                                            <p>{{params.courseshd_terms}}</p>
 
                                        </div>
                                    </div>

                                    </div>
                                </div>
                             
                            </div>
                            <div class="col-xl-5 sticky top-50">
                                <div class="job-sidebar">
                                    <div class="widget-item">
                                        <div class="widget-title">
                                            <h3 class="title">Summery</h3>
                                        </div>
                                        <div class="summery-info">
                                            <table class="table">
                                                <tbody>
                                                    <tr>
                                                        <td class="table-name">COMPANY NAME</td>
                                                        <td class="dotted">:</td>
                                                        <td data-text-color="#03a84e">{{params.COMPANY_NAME}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="table-name">COMPANY EMAIL</td>
                                                        <td class="dotted">:</td>
                                                        <td data-text-color="#03a84e">{{params.COMPANY_EMAIL_ID}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="table-name">COMPANY CONTACT NO.</td>
                                                        <td class="dotted">:</td>
                                                        <td data-text-color="#03a84e">{{params.COMPANY_CONTACT}}</td>
                                                    </tr>

                                                    <tr>
                                                        <td class="table-name">Internship Id</td>
                                                        <td class="dotted">:</td>
                                                        <td data-text-color="#03a84e">{{params.AUTO_GENARATED_INTERNSHIP_ID}}</td>
                                                    </tr>
                                                    <!-- <tr>
                                                        <td class="table-name">FIRST NAME</td>
                                                        <td class="dotted">:</td>
                                                        <td data-text-color="#03a84e">{{params.FIRSTNAME}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="table-name">LAST NAME</td>
                                                        <td class="dotted">:</td>
                                                        <td data-text-color="#03a84e">{{params.LASTNAME}}</td>
                                                    </tr> -->
                                                    <tr>
                                                        <td class="table-name">REGISTRATION START DATE</td>
                                                        <td class="dotted">:</td>
                                                        <td>{{params.REGISTRATION_STARTDATE | date: 'dd-MM-yyyy'}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="table-name">REGISTRATION END DATE</td>
                                                        <td class="dotted">:</td>
                                                        <td>{{params.REGISTRATION_ENDDATE | date: 'dd-MM-yyyy'}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="table-name">INTERNSHIP START DATE</td>
                                                        <td class="dotted">:</td>
                                                        <td>{{params.COURSESHD_STARTDATE | date: 'dd-MM-yyyy'}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="table-name">INTERNSHIP END DATE</td>
                                                        <td class="dotted">:</td>
                                                        <td>{{params.COURSESHD_ENDDATE | date: 'dd-MM-yyyy'}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <button class="mt-3 btn btn-dark btn-sm" (click)="GoToIntrnship()"><i class="bi bi-arrow-left-circle fa-2x"></i>Back</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>